import type { ButtonRenderLink, RenderLink } from '@pms-digital/design-system';
import { Link } from '@tanstack/react-router';
import type { ComponentProps } from 'react';

/**
 * The router's link for the design system's `renderLink` props (`AppShell`,
 * `Card`, `Tabs`, `Breadcrumb`). The package hands over a plain `href`;
 * TanStack's `Link` wants a known route, so the concrete path (e.g.
 * `/companies/<id>`) is passed through as is.
 */
export const renderRouterLink: RenderLink = ({ href, children, ...rest }) => (
  <Link {...({ to: href } as ComponentProps<typeof Link>)} {...rest}>
    {children}
  </Link>
);

/** The same for `Button href`, whose link also takes a ref and the busy / disabled flags. */
export const renderRouterButtonLink: ButtonRenderLink = ({ href, children, ...rest }) => (
  <Link {...({ to: href } as ComponentProps<typeof Link>)} {...rest}>
    {children}
  </Link>
);
